import { render, staticRenderFns } from "./ManagementIframe.vue?vue&type=template&id=7ad8b719&"
import script from "./ManagementIframe.vue?vue&type=script&lang=ts&"
export * from "./ManagementIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports